import requstHelper from './requstHelper';
import store from '../store';
import { getUrlParam, getToken } from '../utils/index';
/* eslint-disable */
class userApi {
    // 默认构造函数
    constructor() {
        return this;
    }

    // 积分流水导出
    /**
     * @param {Object} params-请求参数
     * @param {String} params.userCode-用户code
     */
    static scoreExport = params => requstHelper.fetch('score/export', params, {
        header: {
            token: getToken('token'),
        },
        method: 'GET',
    })

    // 查询积分流水列表
    /**
     * @param {Object} params-请求参数
     * @param {String} params.userCode-用户code
     * @param {Number} params.pageNum-页码
     * @param {Number} params.pageSize-页数
     */
    static getScoreList = params => requstHelper.fetch('score/getScoreList', params, {
        header: {
            token: getToken('token'),
        },
        method: 'GET',
    })

    // 病例导出
    static downloadCase = params => requstHelper.fetch('excel/exportExcel', params, {
        header: {
            token: getToken('token'),
        },
        method: 'GET',
    })
    static getPlatformInfo = params => requstHelper.fetch(`sys/platform/info/${params.id}`, {}, {
        header: {
            token: getToken('token'),
        },
        method: 'GET',
    })
    // 结构管理删除
    static structureDelete = params => requstHelper.fetch(`structure/delete/${params.id}`, {}, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    // 结构管理模块栏目编辑获取信息
    static structureInfo = params => requstHelper.fetch(`structure/info/${params.id}`, {}, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    // 结构管理模块栏目编辑获取信息
    static structureSort = params => requstHelper.fetch(`structure/sort`, params, {
        header: {
            token: getToken('token'),
        },
        method: 'POST',
    })

    // 公共api
    static commonApi = (url, params) => requstHelper.fetch(url, params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
        noLoading: params.noLoading ? false : true
    })
    static commonApiGet = (url, params) => requstHelper.fetch(url, {}, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })

    static commonApiGetNz = params => requstHelper.fetch(`lecturer/info/${params.code}`, {}, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    static commonContentGetNz = params => requstHelper.fetch(`content/info/${params.code}`, {}, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })  
    static getDepartmentList = params => requstHelper.fetch(`content/getDepartmentList`, params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    static lecturerGetup = params => requstHelper.fetch(`lecturer/up/line/${params.code}`, {}, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    static lecturerGetDown = params => requstHelper.fetch(`lecturer/down/line/${params.code}`, {}, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    static contentGetup = params => requstHelper.fetch(`content/up/line/${params.code}`, {}, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    static contentGetDown = params => requstHelper.fetch(`content/down/line/${params.code}`, {}, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })

    // 获取全部科室
    static getAllDepartment = params => requstHelper.fetch('department/getDepartmentList', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取全部职称
    static getAllPosition = params => requstHelper.fetch('position/getPositionList', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })
    // 获取全部病种
    static getDiseaseList = params => requstHelper.fetch('disease/selectList', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取全部模块
    static getModelTree = params => requstHelper.fetch('structure/getStructure', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 调研题目列表
    static getTopicListByCode = params => requstHelper.fetch('topic/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加调研题目
    static insertTopicByCode = params => requstHelper.fetch('topic/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除调研题目
    static deleteTopicById = params => requstHelper.fetch('topic/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 查询调研题目详情
    static queryTopicById = params => requstHelper.fetch('topic/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取会议列表
    static getMeetingList = params => requstHelper.fetch('meeting/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除会议
    static deleteMeetingById = params => requstHelper.fetch('meeting/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取会议详情
    static queryMeetingById = params => requstHelper.fetch('meeting/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加会议
    static insertMeeting = params => requstHelper.fetch('meeting/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改会议
    static updateMeeting = params => requstHelper.fetch('meeting/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 会议上下线
    static onlineMeeting = params => requstHelper.fetch('meeting/onlineAuth', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取Banner列表
    static getBannerList = params => requstHelper.fetch('banner/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除Banner
    static deleteBanner = params => requstHelper.fetch('banner/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // Banner上下线
    static onlineBanner = params => requstHelper.fetch('banner/onlineAuth', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取Banner详情
    static queryBannerById = params => requstHelper.fetch('banner/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加Banner
    static insertBanner = params => requstHelper.fetch('banner/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改Banner
    static updateBanner = params => requstHelper.fetch('banner/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取所属局列表
    static getOfficeList = params => requstHelper.fetch('bureau/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除所属局
    static deleteOffice = params => requstHelper.fetch('bureau/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取所属局详情
    static queryOfficeById = params => requstHelper.fetch('bureau/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加所属局
    static insertOffice = params => requstHelper.fetch('bureau/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改所属局
    static updateOffice = params => requstHelper.fetch('bureau/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 省->市->区->医院级联查询
    static getHospitalDistrictList = params => requstHelper.fetch('hospital/district_list', params, {
        header: {
            encrypt: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 医院新增编辑
    static hosPitalAddUpdate = params => requstHelper.fetch('hospital/add_update', params, {
        header: {
            encrypt: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取医院列表
    static getHospitalList = params => requstHelper.fetch('hospital/list', params, {
        header: {
            encrypt: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取医院详情
    static getHospitalById = params => requstHelper.fetch('hospital/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除医院
    static deleteHospital = params => requstHelper.fetch('hospital/delete', params, {
        header: {
            encrypt: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加医院
    static insertHospital = params => requstHelper.fetch('hospital/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改医院
    static updateHospital = params => requstHelper.fetch('hospital/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取员工列表
    static getStaffList = params => requstHelper.fetch('user/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取员工详情
    static getStaffById = params => requstHelper.fetch('user/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除员工
    static deleteStaff = params => requstHelper.fetch('user/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加员工
    static insertStaff = params => requstHelper.fetch('user/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改员工
    static updateStaff = params => requstHelper.fetch('user/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取所有员工部门--不分页
    static getAllDepartmentList = params => requstHelper.fetch('department/getDepartmentList', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取所有员工职位--不分页
    static getAllPositionList = params => requstHelper.fetch('position/getPositionList', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取所属局级联数据
    static getAllOfficeList = params => requstHelper.fetch('bureau/getBureauList', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取全部代表--不分页
    static getAllBehalfList = params => requstHelper.fetch('user/getBehalfInfo', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取全部医院--不分页
    static getAllHospitalList = params => requstHelper.fetch('hospital/getHospital', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除目标医生
    static deleteCodeDoctor = params => requstHelper.fetch('user/deleteByCodeDoctor', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 医生审核
    static examineDoctor = params => requstHelper.fetch('user/checkCertification', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取病例列表
    static getCaseList = params => requstHelper.fetch('case/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取病例详情
    static queryCaseByCode = params => requstHelper.fetch('case/detail', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除病例
    static deleteCase = params => requstHelper.fetch('case/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加病例
    static insertCase = params => requstHelper.fetch('case/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改病例
    static updateCase = params => requstHelper.fetch('case/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 病例上下线
    static onlineCase = params => requstHelper.fetch('case/updateStatus', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取全部标签-code
    static getAllLabelList = params => requstHelper.fetch('case/label', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取直播列表-内容
    static getLiveList = params => requstHelper.fetch('video/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取直播详情-内容
    static getLiveByCode = params => requstHelper.fetch('video/detail', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除直播-内容
    static deleteLive = params => requstHelper.fetch('video/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加直播-内容
    static insertLive = params => requstHelper.fetch('video/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改直播-内容
    static updateLive = params => requstHelper.fetch('video/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 直播上下线-内容
    static onlineLive = params => requstHelper.fetch('video/updateStatus', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取相关推荐列表-内容
    static getRecommendList = params => requstHelper.fetch('case/getContents', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取内容列表
    static getContentList = params => requstHelper.fetch('content/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取内容详情
    static getContentByCode = params => requstHelper.fetch('content/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除内容
    static deleteContent = params => requstHelper.fetch('content/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加内容
    static insertContent = params => requstHelper.fetch('content/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改内容
    static updateContentByCode = params => requstHelper.fetch('content/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 内容上下线
    static onlineContent = params => requstHelper.fetch('content/onlineAuth', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取奖品列表
    static getAwardListByCode = params => requstHelper.fetch('award/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取奖品详情
    static getAwardByCode = params => requstHelper.fetch('award/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除奖品
    static deleteAwardByCode = params => requstHelper.fetch('award/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加奖品
    static insertAward = params => requstHelper.fetch('award/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改奖品
    static updateAward = params => requstHelper.fetch('award/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取抽奖列表
    static getLotteryList = params => requstHelper.fetch('lottery/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取抽奖详情
    static getLotteryByCode = params => requstHelper.fetch('lottery/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除抽奖
    static deleteLottery = params => requstHelper.fetch('lottery/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加抽奖
    static insertLottery = params => requstHelper.fetch('lottery/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改抽奖
    static updateLottery = params => requstHelper.fetch('lottery/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 抽奖上下线
    static onlineLottery = params => requstHelper.fetch('lottery/onlineAuth', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取互动答题列表
    static getQaList = params => requstHelper.fetch('interactive/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取互动答题详情
    static getQaByCode = params => requstHelper.fetch('interactive/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除互动答题
    static deleteQaByCode = params => requstHelper.fetch('interactive/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加互动答题
    static insertQa = params => requstHelper.fetch('interactive/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改互动答题
    static updateQaByCode = params => requstHelper.fetch('interactive/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 互动答题上下线
    static onlineQa = params => requstHelper.fetch('interactive/onlineAuth', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取全部互动答题列表
    static getAllQaList = params => requstHelper.fetch('interactive/getRecommendInfo', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取全部抽奖列表
    static getAllLotteryList = params => requstHelper.fetch('lottery/getLottery', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取省市区
    static getAreaByLevel = params => requstHelper.fetch('district/getDistrict', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取七牛云上传Token
    static getQiniuyunToken = params => requstHelper.fetch('sys/oss/getUpToken', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    // 编辑病种名称获取信息
    static getDiseaseInfo = params => requstHelper.fetch(`disease/info/${params.id}`, {}, {
        header: {
            token: getToken('token'),
        },
        method: 'GET',
    })
    static getDiseaseDelete = params => requstHelper.fetch(`disease/delete/${params.id}`, {}, {
        header: {
            token: getToken('token'),
        },
        method: 'GET',
    })

    // 删除下级代表
    static deleteLower = params => requstHelper.fetch('user/unbundling', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取领域列表
    static getDomainList = params => requstHelper.fetch('belongsTerritory/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取领域
    static getDomainByCode = params => requstHelper.fetch('belongsTerritory/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除领域
    static deleteDomainByCode = params => requstHelper.fetch('belongsTerritory/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加领域
    static insertDomain = params => requstHelper.fetch('belongsTerritory/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改领域
    static updateDomain = params => requstHelper.fetch('belongsTerritory/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取产品列表
    static getProductList = params => requstHelper.fetch('product/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取产品
    static getProduct = params => requstHelper.fetch('product/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除产品
    static deleteProduct = params => requstHelper.fetch('product/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加产品
    static insertProduct = params => requstHelper.fetch('product/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改产品
    static updateProduct = params => requstHelper.fetch('product/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取全部领域列表
    static getAllDomainList = params => requstHelper.fetch('belongsTerritory/getTerritory', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取推广材料列表
    static getPromoteList = params => requstHelper.fetch('material/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取推广材料
    static getPromote = params => requstHelper.fetch('material/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除推广材料
    static deletePromote = params => requstHelper.fetch('material/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加推广材料
    static insertPromote = params => requstHelper.fetch('material/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改推广材料
    static updatePromote = params => requstHelper.fetch('material/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 推广材料上下线
    static onlinePromote = params => requstHelper.fetch('material/onlineAuth', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取领域产品树
    static getDomainProductTree = params => requstHelper.fetch('product/getProduct', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取商品类别列表
    static getCategoryList = params => requstHelper.fetch('commodityCategory/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取商品类别
    static getCategory = params => requstHelper.fetch('commodityCategory/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除商品类别
    static deleteCategory = params => requstHelper.fetch('commodityCategory/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加商品类别
    static insertCategory = params => requstHelper.fetch('commodityCategory/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改商品类别
    static updateCategory = params => requstHelper.fetch('commodityCategory/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取商品列表
    static getGoodsList = params => requstHelper.fetch('commodity/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取商品
    static getGoods = params => requstHelper.fetch('commodity/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除商品
    static deleteGoods = params => requstHelper.fetch('commodity/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加商品
    static insertGoods = params => requstHelper.fetch('commodity/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改商品
    static updateGoods = params => requstHelper.fetch('commodity/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 商品上下线
    static onlineGoods = params => requstHelper.fetch('commodity/onlineAuth', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取全部商品类别列表
    static getAllCategoryList = params => requstHelper.fetch('commodityCategory/getCategory', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取订单列表
    static getOrderList = params => requstHelper.fetch('order/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取订单详情
    static getOrder = params => requstHelper.fetch('order/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除订单
    static deleteOrder = params => requstHelper.fetch('order/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 订单发货
    static sendOrder = params => requstHelper.fetch('order/updateOrder', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取订单物流信息
    static queryExpInfo = params => requstHelper.fetch('queryExpInfo/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--医生基础数据
    static queryDoctorBasicDataAi = params => requstHelper.fetch('stati/getData', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--医生注册累计
    static queryDoctorSignIn = params => requstHelper.fetch('stati/queryCnt', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--用户活跃人数统计
    static queryEveryDayUserData = params => requstHelper.fetch('stati/queryActiveCnt', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--医生用户列表
    static queryDoctorListData = params => requstHelper.fetch('stati/queryDoctorList', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--代表推送记录
    static queryStaffShareData = params => requstHelper.fetch('stati/queryMaritalInfoList', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--员工列表
    static queryStaffDataAi = params => requstHelper.fetch('stati/queryStaffList', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--资讯运营基础数据
    static queryNewsBasicData = params => requstHelper.fetch('stati/queryContentData', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--资讯运营阅读统计
    static queryNewsReadData = params => requstHelper.fetch('stati/getReadPvUv', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--资讯运营分享统计
    static queryNewsShareData = params => requstHelper.fetch('stati/getSharePv', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--会议详情基础数据
    static queryNewsInfoBasicData = params => requstHelper.fetch('stati/getContentDetailData', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--会议详情饼图数据
    static queryNewsInfoPieData = params => requstHelper.fetch('stati/getContentDetailByDppData', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--会议详情用户列表数据
    static queryNewsInfoUserData = params => requstHelper.fetch('stati/queryContentDetailByUser', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--会议详情报名数据
    static queryNewsInfoPartInData = params => requstHelper.fetch('stati/queryContentDetailPartIn', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--活动数据基础数据
    static queryActivtyBasicData = params => requstHelper.fetch('stati/queryTopicDetailData', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--活动数据参与人数统计
    static queryActivtyPartInData = params => requstHelper.fetch('stati/querySurvyPartInCount', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--活动数据用户列表
    static queryActivtyUserData = params => requstHelper.fetch('stati/queryTopicByUser', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--活动数据互动答题
    static queryActivtyQaData = params => requstHelper.fetch('stati/queryStaffPartCount', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 数据报表--互动答题答题记录
    static queryActivtyQaTopicRecord = params => requstHelper.fetch('stati/queryInteractiveData', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取消息分组列表--分页
    static queryMsgGroupList = params => requstHelper.fetch('message/group/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取消息分组
    static queryMsgGroupInfo = params => requstHelper.fetch('message/group/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除消息分组
    static deleteMsgGroup = params => requstHelper.fetch('message/group/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加消息分组
    static insertMsgGroup = params => requstHelper.fetch('message/group/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改消息分组
    static updateMsgGroup = params => requstHelper.fetch('message/group/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 消息分组--用户列表
    static queryUserByGroup = params => requstHelper.fetch('message/getBaseList', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 消息分组--添加到分组
    static pushUserGroup = params => requstHelper.fetch('message/focusGroup', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 消息分组--全选成员
    static pushAllUserIn = params => requstHelper.fetch('message/checkAll', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 消息分组--移出分组
    static moveUserGroup = params => requstHelper.fetch('message/moveFocusGroup', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取全部消息分组--不分页
    static queryAllMsgGroup = params => requstHelper.fetch('message/getGroup', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取模板消息列表
    static queryMsgList = params => requstHelper.fetch('message/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取模板消息
    static queryMsg = params => requstHelper.fetch('message/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 删除模板消息
    static deleteMsg = params => requstHelper.fetch('message/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 添加模板消息
    static insertMsg = params => requstHelper.fetch('message/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 修改模板消息
    static updateMsg = params => requstHelper.fetch('message/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 推送模板消息
    static sendMsgToWX = params => requstHelper.fetch('message/send', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 名医导师-获取问答列表
    static queryConyList = params => requstHelper.fetch('expert/queryQuestion', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 名医导师-获取问答详情
    static queryCony = params => requstHelper.fetch('expert/questioninfo', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 名医导师-问答审核
    static conyAudit = params => requstHelper.fetch('expert/checkQuestion', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 名医导师-问答上下线
    static conyOnline = params => requstHelper.fetch('expert/onlineAuth', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 名医导师-修改回复
    static updateConyAnswer = params => requstHelper.fetch('expert/updateReplyAnswer', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 名医导师-回复
    static conyAnswer = params => requstHelper.fetch('expert/replyAnswer', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 名医导师-删除问答
    static deleteCony = params => requstHelper.fetch('expert/deleteQuestion', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 用户行为记录-医生列表
    static getDoctorRecordList = params => requstHelper.fetch('stati/queryBehaviorDoctor', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 用户行为记录-内容记录
    static getContentRecord = params => requstHelper.fetch('stati/queryContentBehavior', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 用户行为记录-会议记录
    static getMeetRecord = params => requstHelper.fetch('stati/queryMeetBehavior', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 用户行为记录-答题记录
    static getAnswerRecord = params => requstHelper.fetch('stati/queryInteractiveBehavior', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 用户行为记录-调研记录
    static getResearchRecord = params => requstHelper.fetch('stati/querySurvyBehavior', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 用户行为记录-员工记录
    static getStaffRecordList = params => requstHelper.fetch('stati/queryStaffBehavior', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 用户行为记录-推广记录
    static getRecommendRecord = params => requstHelper.fetch('stati/queryBehaviorMaterial', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 白名单医生-获取列表
    static getAuthList = params => requstHelper.fetch('backUp/list', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 白名单医生-添加
    static insertAuth = params => requstHelper.fetch('backUp/save', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 白名单医生-编辑
    static updateAuth = params => requstHelper.fetch('backUp/update', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 白名单医生-删除
    static deleteAuth = params => requstHelper.fetch('backUp/delete', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 白名单医生-详情
    static queryAuthInfo = params => requstHelper.fetch('backUp/info', params, {
        header: {
            token: getToken('token'),
            'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 获取公司logo
    static getCompanyLogo = params => requstHelper.fetch('query/company/detail', params, {
        header: {
            token: getUrlParam('token'),
        },
        method: 'GET',
    })

    // 获取新消息通知
    static getNewMsg = (params) => {
        const userInfo = store.getters['user/userInfo'](params.companyCode);
        return requstHelper.fetch('message/msg/new', {}, {
            header: {
                token: userInfo.token,
            },
            method: 'GET',
        });
    }

    // 转换key值，部分接口不支持json
    static stringify = (param) => {
        const query = [];
        Object.keys(param).forEach((key) => {
            query.push(`${key}=${param[key]}`);
        });
        return query.join('&');
    }

    // 获取结构列表
    static getStructureList = params => requstHelper.fetch('content/getStructureList', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    // 获取作者讲者列表
    static getAuthorList = params => requstHelper.fetch('lecturer/selectAll', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    // 获取标签列表
    static labelList = params => requstHelper.fetch('course/getLabelList', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //保存课程
    static saveCourse = params => requstHelper.fetch('/course/save', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //课程列表
    static getCourseList = params => requstHelper.fetch('/course/list', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    static getCourseDetail = params => requstHelper.fetch(`course/info/${params.code}`, params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    //更新课程
    static updateCourse = params => requstHelper.fetch('/course/update', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //更新讲师
    static updateLecture = params => requstHelper.fetch('/course/edit/expert', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //课程新增讲师返回code
    static addLecture = params => requstHelper.fetch('/course/expert/save', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    static updateSection = params => requstHelper.fetch('/course/edit/section', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    
    //删除讲师
    static delLecture = params => requstHelper.fetch(`/course/delete/expert/${params.expertCode}`, {}, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    //删除章节
    static delSection = params => requstHelper.fetch(`/course/delete/section/${params.sectionCode}`, {}, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    //上线课程
    static courseGetup = params => requstHelper.fetch(`/course/up/line/${params.code}`, {}, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    //下线课程
    static courseGetDown = params => requstHelper.fetch(`/course/down/line/${params.code}`, {}, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    //文章列表
    static articleList = params => requstHelper.fetch('article/list', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    //文章详情
    static articleDetail = params => requstHelper.fetch(`/article/info/${params.code}`, {}, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    //相关推荐
    static articleRecommend = params => requstHelper.fetch('article/getArticleList', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    //编辑文章
    static articleUpdate = params => requstHelper.fetch('article/update', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //新建文章
    static articleSave = params => requstHelper.fetch('article/save', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //文章上线下线
    static onlineAuth = params => requstHelper.fetch('article/onlineAuth', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //文章删除
    static articleDel = params => requstHelper.fetch('article/delete', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //文章复制
    static articleCopy = params => requstHelper.fetch('article/copy', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //视频列表
    static videoList = params => requstHelper.fetch('video/list', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    //视频详情
    static videoDetail = params => requstHelper.fetch(`/video/info/${params.code}`, {}, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    //相关推荐
    static videoRecommend = params => requstHelper.fetch('video/getVideoList', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    //编辑视频
    static videoUpdate = params => requstHelper.fetch('video/update', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //复制视频
    static videoCopy = params => requstHelper.fetch('video/copy', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //新建视频
    static videoSave = params => requstHelper.fetch('video/save', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //视频上线下线
    static onlineVideo = params => requstHelper.fetch('video/onlineAuth', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //视频删除
    static videoDel = params => requstHelper.fetch('video/delete', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //视频节点编辑
    static videoNodesEdit = params => requstHelper.fetch('video/nodes_edit', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //学分列表
    static creditList = params => requstHelper.fetch('video_credit/list', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    static ywzlWhiteList = params => requstHelper.fetch('ywzl/white/list', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    
    //学分审核
    // static creditAuth = params => requstHelper.fetch('video_credit/auth', params, {
    //     header: {
    //         encrypt: getToken('token'),
    //     },
    //     method: 'POST',
    // })
    //学分发放
    static creditAuth = params => requstHelper.fetch('video_credit/grant', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //用户列表
    static userBaseList = params => requstHelper.fetch('userBase/v2/list', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    // 用户列表导出
    static userBaseExport = params => requstHelper.fetch('common/export/user/list', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
        responseType: 'blob',
    })
    // 通用科室树
    static deptList = params => requstHelper.fetch('/appointment/expert/dept/list', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'post',
    })
    //题目列表
    static topicList = params => requstHelper.fetch('topic/list', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    //题目保存
    static topicSave = params => requstHelper.fetch('topic/save', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //题目删除
    static topicDel = params => requstHelper.fetch('topic/delete', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //banner列表
    static bannerList = params => requstHelper.fetch('banner/list', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    //banner详情
    static bannerInfo = params => requstHelper.fetch('banner/info/'+params.code, params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    //banner新增
    static bannerSave = params => requstHelper.fetch('banner/save', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //banner编辑
    static bannerUpdate = params => requstHelper.fetch('banner/update', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //banner上下线
    static bannerOnlineAuth = params => requstHelper.fetch('banner/onlineAuth', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //banner删除
    static bannerDel = params => requstHelper.fetch('banner/delete', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //视频题目积分保存
    static videoTopicUpdate = params => requstHelper.fetch('video/topicUpdate', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //文章题目积分保存
    static articleTopicUpdate = params => requstHelper.fetch('article/topicUpdate', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //专家列表
    static specialist = params => requstHelper.fetch('specialist/list', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    //专家详情
    static specialistInfo = params => requstHelper.fetch('specialist/getSpecialistInfo/'+params.code, params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    //专家编辑
    static specialistUpdate = params => requstHelper.fetch('specialist/update', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //专家新增
    static specialistAdd = params => requstHelper.fetch('specialist/add', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //专家删除
    static specialistDel = params => requstHelper.fetch('specialist/del', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //通用科室列表
    static getDepartmentList = params => requstHelper.fetch('/ysz/common/ysz/dept/list', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //通用科室新增
    static addDepartment = params => requstHelper.fetch('/ysz/common/ysz/dept/add', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //通用科室编辑
    static editDepartment = params => requstHelper.fetch('/ysz/common/ysz/dept/edit', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //结构列表
    static structureList = params => requstHelper.fetch('base/structure/list', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    //结构列表树
    static structureTree = params => requstHelper.fetch('base/structure/listTree', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    //结构新增
    static structureSave = params => requstHelper.fetch('base/structure/save', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //结构详情
    static structureInfo = params => requstHelper.fetch('base/structure/info/'+params.id, params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    //结构编辑
    static structureUpdate = params => requstHelper.fetch('base/structure/update', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //结构删除
    static structureDelete = params => requstHelper.fetch('base/structure/delete', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //标签列表
    static baseLabelList = params => requstHelper.fetch('base/label/list', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    //标签新增
    static labelSave = params => requstHelper.fetch('base/label/save', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //标签详情
    static labelInfo = params => requstHelper.fetch('base/label/info/'+params.id, params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    //标签编辑
    static labelUpdate = params => requstHelper.fetch('base/label/update', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //标签删除
    static labelDelete = params => requstHelper.fetch('base/label/delete', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //职称列表
    static positionList = params => requstHelper.fetch('base/position/list', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'GET',
    })
    //职称新增
    static positionSave = params => requstHelper.fetch('base/position/save', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //职称详情
    static positionInfo = params => requstHelper.fetch('base/position/info/'+params.id, params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    //职称编辑
    static positionUpdate = params => requstHelper.fetch('base/position/update', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //职称删除
    static positionDelete = params => requstHelper.fetch('base/position/delete', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //通用职称列表
    static yszpositionList = params => requstHelper.fetch('ysz/common/ysz/position/list', params, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })
    //通用职称新增
    static yszpositionSave = params => requstHelper.fetch('ysz/common/ysz/position/add', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //通用职称编辑
    static yszpositionUpdate = params => requstHelper.fetch('ysz/common/ysz/position/edit', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //通用职称删除
    static yszpositionDelete = params => requstHelper.fetch('ysz/common/ysz/position/delete', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    
    //获取专区科室列表
    static getAreaDepartmentList = params => requstHelper.fetch('base/areaDepartment/list', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    //获取科室列表
    static getDepartmentLists = params => requstHelper.fetch('base/department/getDepartmentList', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    //专区科室删除
    static delAreaDepartment = params => requstHelper.fetch('base/areaDepartment/delete', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //新增专区科室
    static saveAreaDepartment = params => requstHelper.fetch('base/areaDepartment/save', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //修改专区科室
    static updateAreaDepartment = params => requstHelper.fetch('base/areaDepartment/update', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    //获取专区数据详情
    static getAreaDepartmentInfo = params => requstHelper.fetch(`base/areaDepartment/info/${params.id}`, params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    //查询动态菜单列表
    static getWeChatMenuList = params => requstHelper.fetch('weChat/dynamicMenu/list', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    // 上线动态菜单列表
    static onlineAuthWeChatMenu = params => requstHelper.fetch('weChat/dynamicMenu/onlineAuth', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    // 删除菜单
    static delWeChatMenu = params => requstHelper.fetch(`weChat/dynamicMenu/delete/${params.id}`, params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    // 新增动态菜单列表
    static saveWeChatMenu = params => requstHelper.fetch('weChat/dynamicMenu/save', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    // 修改动态菜单列表
    static updateWeChatMenu = params => requstHelper.fetch('weChat/dynamicMenu/update', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    static studyList = params => requstHelper.fetch('ywzl/study/list', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    static commentList = params => requstHelper.fetch('ywzl/comment/list', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    static statementAuth = params => requstHelper.fetch('ywzl/comment/check', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    static commentDelete = params => requstHelper.fetch('ywzl/comment/del', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'POST',
    })
    
    
    //获取菜单数据详情
    static getDynamicMenuInfo = params => requstHelper.fetch(`weChat/dynamicMenu/info/${params.id}`, params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    //获取医生站科室信息
    static getDynamicMenuDepartments = params => requstHelper.fetch('weChat/dynamicMenu/getDepartments', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    
    //获取公众号列表
    static getWxAppIdconfig = params => requstHelper.fetch('weChat/dynamicMenu/wx/config', params, {
        header: {
            encrypt: getToken('token')
        },
        method: 'GET',
    })
    //查询调研列表
    static getSurveyList = params => requstHelper.fetch('user/survey/list', {
        ...params,
        companyCode: 'NHND-GS',
        areaCode: 'NH',
    }, {
        header: {
            encrypt: getToken('token'),
        },
        method: 'POST',
    })

    // 查询用户版权信息列表
    static getCopyrightList = params => requstHelper.fetch('user/copyright/listSync', params, {
        header: {
            token: getToken('token'),
            encrypt: getToken("token")
            // 'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })

    // 肾病科普分配版权
    static allocateCopyright = params => requstHelper.fetch('user/copyright/sbkp/allocation', params, {
        header: {
            token: getToken('token'),
            encrypt: getToken("token"),
            // 'yxj-encrypt': 'yes_mis'
        },
        method: 'POST',
    })
}

export default userApi;



// WEBPACK FOOTER //
// ./src/api/userAPI.js